<select
    *ngIf="rowData && disabled != null"
    [disabled]="disabled"
    [(ngModel)]="rowData[property]"
    style="width: 100%; min-width: 100%; max-width: 100%"
>
    <option *ngFor="let item of items" [value]="item.value">
        {{ item.label }}
    </option>
</select>
<select
    *ngIf="rowData && disabled == null"
    [(ngModel)]="rowData[property]"
    style="width: 100%; min-width: 100%; max-width: 100%"
>
    <option *ngFor="let item of items" [value]="item.value">
        {{ item.label }}
    </option>
</select>